// extracted by mini-css-extract-plugin
module.exports = {"component":"Announcement_component__3OhWL"};